import { apolloClient } from './graphql_client';
import { gql } from '@apollo/client';
import { updatePendingEmailOtpChallenge } from './wordpress_auth';
import { verifyEmailOtpStep, AuthStepResult } from './wordpress_totp';

const RESEND_EMAIL_OTP = gql`
  mutation ResendEmailOtp($challengeToken: String!) {
    resendEmailOtp(input: { challengeToken: $challengeToken }) {
      success
      challengeToken
      emailHint
      expiresIn
    }
  }
`;

const extractError = (error: any, fallback: string): string => {
  if (error?.graphQLErrors?.[0]?.message) return error.graphQLErrors[0].message;
  if (error?.networkError?.message) return error.networkError.message;
  if (error?.message) return error.message;
  return fallback;
};

/** After email OTP: may return JWT, TOTP challenge, or TOTP setup challenge. */
export const verifyEmailOtp = async (
  challengeToken: string,
  code: string
): Promise<AuthStepResult> => {
  return verifyEmailOtpStep(challengeToken, code);
};

export const resendEmailOtp = async (
  challengeToken: string
): Promise<{ challengeToken: string; emailHint?: string | null }> => {
  try {
    const { data } = await apolloClient.mutate<{
      resendEmailOtp?: {
        success?: boolean | null;
        challengeToken?: string | null;
        emailHint?: string | null;
      } | null;
    }>({
      mutation: RESEND_EMAIL_OTP,
      variables: { challengeToken },
    });

    const payload = data?.resendEmailOtp;
    if (!payload?.success || !payload.challengeToken) {
      throw new Error('Unable to resend verification code.');
    }

    updatePendingEmailOtpChallenge(payload.challengeToken, payload.emailHint);
    return {
      challengeToken: payload.challengeToken,
      emailHint: payload.emailHint,
    };
  } catch (error: any) {
    throw new Error(extractError(error, 'Unable to resend verification code.'));
  }
};
